import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);

interface UniqueSliderModel {
    prevBtn: String;
    nextBtn: String;
    pagiBtn: String;
}

class SliderPlugin {

    static type: String = ""
    swiper: Swiper;
    element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
        this.init();
    }

    getClassPath(): string {
        return `.${this.element.classList.toString().replaceAll(" ", ".")}`
    }

    // Now made unique in velocity
    // makeUnique(): UniqueSliderModel {
    //     let uuid = this.makeCssSelector(10);
    //     let nextBtn = ".swiper-button-next";
    //     let prevBtn = ".swiper-button-prev";
    //     let pagiBtn = ".swiper-pagination";
    //     this.element.classList.add(uuid);
    //     this.element.parentNode.querySelector(".swiper-button-next")
    //         .classList.add(`${nextBtn}-${uuid}`.replace(".", ""))
    //     this.element.parentNode.querySelector(".swiper-button-prev")
    //         .classList.add(`${prevBtn}-${uuid}`.replace(".", ""))
    //     this.element.parentNode.querySelector(".swiper-pagination")
    //         .classList.add(`${pagiBtn}-${uuid}`.replace(".", ""))
    //     return {
    //         prevBtn: `${pagiBtn}-${uuid}`,
    //         nextBtn: `${nextBtn}-${uuid}`,
    //         pagiBtn: `${prevBtn}-${uuid}`
    //     }
    // }
    // makeCssSelector(length) {
    //     // brought to you by |_Genos_|
    //     var result           = '';
    //     var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    //     var charactersLength = characters.length;
    //     for ( var i = 0; i < length; i++ ) {
    //         result += characters.charAt(Math.floor(Math.random() * 
    //         charactersLength));
    //     }
    //    return result;
    // }

    getButtons(): UniqueSliderModel {
        let sliderId = this.element.dataset.sliderId;
        return {
            prevBtn: `.${sliderId}-prev`,
            nextBtn: `.${sliderId}-next`,
            pagiBtn: `.${sliderId}-pagi`
        }
    }

    init() {
        // do init things
    }
}
export default SliderPlugin;